import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=2c307115"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=2c307115&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports